<template>

    <form v-on:submit.prevent="">

        <BaseInputFloatinglabel type="text"
                   placeholder="Name"
                   v-model="form.name" icon="th"/>

        <div class="action">
          <BaseButton v-if="type === 'create'"
                       :loading="creating"
                       :disabled="checkForm || creating"
                       icon="plus"
                       label="Erstellen"
                       :submit="true"
                       @click="create"/>
          <BaseButton v-if="hasManagerRole && type === 'edit'"
                       :loading="removing"
                       :disabled="removing"
                       icon="trash"
                       label="Löschen"
                       :remove="true"
                       @click="remove"/>
          <BaseButton v-if="type === 'edit'"
                       :loading="updating"
                       :disabled="checkForm || updating"
                       icon="save"
                       label="Speichern"
                       :submit="true"
                       @click="update"/>
        </div>

    </form>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  name: 'InfluencerSubCategoryForm',
  props: ['influencerSubCategory', 'type'],
  data () {
    return {
      form: {
        name: null
      },
      creating: false,
      updating: false,
      removing: false
    }
  },
  created () {
    this.form = cloneDeep(this.influencerSubCategory)
  },
  methods: {
    async create () {
      try {
        this.creating = true
        const response = await this.createInfluencerSubCategory({ data: this.form })
        await this.getInfluencerSubCategories()
        this.$vfm.hide('influencer-sub-category-create')
        this.$toasted.success('Influencer Schwerpunkt ' + response.data.name + ' erstellt', { icon: 'fas fa-th' })
        this.creating = false
      } catch (error) {
        this.creating = false
      }
    },
    async update () {
      try {
        this.updating = true
        const response = await this.updateInfluencerSubCategory({ id: this.form.id, data: this.form })
        await this.getInfluencerSubCategories()
        this.$vfm.hide('influencer-sub-category-edit')
        this.$toasted.success('Influencer Schwerpunkt ' + response.data.name + ' gespeichert', { icon: 'fas fa-th' })
        this.updating = false
      } catch (error) {
        this.updating = false
      }
    },
    async remove () {
      try {
        this.removing = true
        await this.deleteInfluencerSubCategory({ id: this.form.id })
        this.$vfm.hide('influencer-sub-category-edit')
        this.$toasted.success('Influencer Schwerpunkt gelöscht', { icon: 'fas fa-th' })
        this.removing = false
      } catch (error) {
        this.removing = false
      }
    },
    ...mapActions({
      createInfluencerSubCategory: 'influencerSubCategories/create',
      updateInfluencerSubCategory: 'influencerSubCategories/replace',
      deleteInfluencerSubCategory: 'influencerSubCategories/destroy',
      getInfluencerSubCategories: 'influencerSubCategories/fetchList'
    })
  },
  computed: {
    checkForm () {
      return !this.form.name
    },
    ...mapGetters({
      hasManagerRole: 'auth/hasManagerRole'
    })
  }
}
</script>
